import { FormikHelpers } from "formik";
import CityForm from "./CityForm";
import { useGetCity } from "./api/getCity";
import { useEditCity } from "./api/editCity";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";


const EditCity = ({handleCloseModal, cityId}: EditCityProps)  => {
  const getCityQuery = useGetCity({cityId: cityId})
  const editCityMutation = useEditCity({data: {}, cityId});

  const handleSubmit = async (values: IPostEditCity, { setSubmitting }: FormikHelpers<IPostEditCity>): Promise<void> => {
    try {
      await editCityMutation.mutateAsync({
        data: values,
        cityId: cityId
      });
      handleCloseModal();
    }catch(error){
      console.log("values",values)
    } finally {
	    setSubmitting(false);
    }
  }

  if (getCityQuery.isLoading) {
    return (
      <div className="p-5">
        <LoadingSpinner />
      </div>
    )
  }

  if (getCityQuery.error) {
    return (
      <div>Υπήρξε κάποιο πρόβλημα στην ανάκτηση της Πόλης.</div>
    )
  }

  return (
    <>
      {!getCityQuery.isLoading && getCityQuery.data &&
        <CityForm initialValues={getCityQuery.data} type="edit" onSubmit={handleSubmit} />
      }
    </>
  )
}

interface EditCityProps {
  cityId: number;
  handleCloseModal: () => void;
}

export default EditCity;